import React from 'react';
import optc from '../optc.json'
import { useTranslation } from "react-i18next";


const Licences = () => {

  const [t] = useTranslation('common');

  return (
    <div className="row justify-content-center">

      <div className="col-lg-6 col-11">

        <h1 className="text-center pt-3 display-4">{t('privacy.title')}</h1>

        <p className="pt-3">{t('privacy.intro.intro1')}</p>

        <p>{t('privacy.intro.intro2')}</p>

        <p>{t('privacy.intro.intro3')}</p>

        <p>{t('privacy.intro.intro4')}</p>


        <h2 className="pt-3"><b>{t('privacy.cookies.subtitle1')}</b></h2>

        <h4>{t('privacy.cookies.subsection1')}</h4>
        <p>{t('privacy.cookies.cookies1')}</p>

        <h4>{t('privacy.cookies.subsection2')}</h4>
        <ol>
          <li><strong>{t('privacy.cookies.strict')}</strong> {t('privacy.cookies.strict1')}</li>
          <li><strong>{t('privacy.cookies.function')}</strong> {t('privacy.cookies.function1')}</li>
        </ol>

        <h4>{t('privacy.cookies.subsection3')}</h4>
        <p>{t('privacy.cookies.consent')}</p>

        <h4>{t('privacy.cookies.subsection4')}</h4>
        <p>{t('privacy.cookies.collection')}</p>

        <h4>{t('privacy.cookies.subsection5')}</h4>
        <p>{t('privacy.cookies.thirdparty')}</p>



        <h2 className="pt-3"><b>{t('privacy.email.subtitle1')}</b></h2>

        <p>{t('privacy.email.email1')}</p>

        <h4>{t('privacy.email.subsection1')}</h4>
        <ol>
          <li>{t('privacy.email.communication')}</li>
          <li>{t('privacy.email.periodic')}</li>
        </ol>

        <h4>{t('privacy.email.subsection2')}</h4>
        <p>{t('privacy.email.security')}</p>

        <h4>{t('privacy.email.subsection3')}</h4>
        <p>{t('privacy.email.retention')}</p>

        <h4>{t('privacy.email.subsection4')}</h4>
        <p className="pb-2">{t('privacy.email.rights')}</p>


        
        <h2 className="pt-3"><b>{t('privacy.update.subtitle1')}</b></h2>

        <p>{t('privacy.update.part1')}</p>

        <p>{t('privacy.update.part2')}</p>


        <h2 className="pt-3"><b>{t('privacy.contact.info')}</b></h2>

        <div className="pb-3">
          <p><strong>Cardinal Data Solutions</strong></p>
          <p><strong>{t('privacy.contact.email')}</strong> info@cardinaldatasolutions.com</p>
        </div>


      </div>
    </div>
  )

}

export default Licences;
